import { render, staticRenderFns } from "./JCElderlyData.vue?vue&type=template&id=bcb4d3e0&scoped=true&"
import script from "./JCElderlyData.vue?vue&type=script&lang=js&"
export * from "./JCElderlyData.vue?vue&type=script&lang=js&"
import style0 from "./JCElderlyData.vue?vue&type=style&index=0&id=bcb4d3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb4d3e0",
  null
  
)

export default component.exports